import { Features } from '../constants/features';
import { usePlanFeatureGate } from './use-plan-feature-gate';

export const useReportsViewOnlyFeatureGate = () => usePlanFeatureGate(Features.ReportsViewOnly);
